import { createContext, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import * as dataIt from "../data/site";
import * as dataEn from "../data/site.en";
import { UI_IT } from "./ui.it";
import { UI_EN } from "./ui.en";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const location = useLocation();
  const lang = location.pathname === "/en" || location.pathname.startsWith("/en/") ? "en" : "it";

  const l = (path) => {
    if (lang === "it") return path;
    return path === "/" ? "/en" : `/en${path}`;
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const value = {
    lang,
    l,
    data: lang === "en" ? dataEn : dataIt,
    t: lang === "en" ? UI_EN : UI_IT,
  };

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
